module.exports = __webpack_public_path__ + "media/theme/blog__border-9-67938a47.png";